import {
  ChatBubble,
  ChatBubbleOutline,
  CloseOutlined,
  Person,
  ReviewsOutlined,
} from "@mui/icons-material";
import { Box, Typography, Drawer, Rating, Grid, Divider } from "@mui/material";
import SelectableChip from "components/SelectableChip";
import TimezoneChip from "components/TimezoneChip";
import ReviewCard from "features/searchStore/components/ReviewCard";
import { filterChips, reviewList } from "features/searchStore/mockupApi";
import { selectStoreDetail } from "features/searchStore/saga/searchStoreSlice";
import { useState } from "react";
import { useAppSelector } from "redux/hooks";

export function ReviewDrawerBtn() {
  const [openReview, setOpenReview] = useState(false);
  const storeData = useAppSelector(selectStoreDetail);
  const [selectedFilter, setSelectedFilter] = useState();

  const handleSeletedChip = (e: any) => {
    // console.log(e);
  };

  return (
    <>
      <Box
        display="flex"
        flex={1}
        alignItems="center"
        justifyContent="center"
        borderRight={1}
        borderColor="divider"
        p={2}
        sx={{
          cursor: "pointer",
          "&:hover": {
            opacity: "0.6",
          },
        }}
        onClick={() => setOpenReview(true)}
      >
        <ChatBubbleOutline color="primary" sx={{ mx: 1 }} />
        <Typography>クチコミ</Typography>
      </Box>
      <Drawer
        anchor="right"
        open={openReview}
        onClose={() => setOpenReview(false)}
        sx={{
          "& .MuiDrawer-paper": {
            overflowY: "visible",
          },
        }}
      >
        <Box display="flex" flexDirection="column" width={800} p={5}>
          <Box
            position="absolute"
            left="-70px"
            top={15}
            sx={{
              "&:hover": {
                cursor: "pointer",
              },
            }}
            onClick={() => setOpenReview(false)}
          >
            <CloseOutlined style={{ color: "white", fontSize: "50px" }} />
          </Box>
          <Typography variant="h5" fontWeight="bold">{`クチコミ (${123} 件)`}</Typography>

          <Box display="flex" width="100%" alignItems="center">
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              p={3}
            >
              <Typography>総合評価</Typography>
              <Typography fontSize="25px" fontWeight="bold" sx={{ my: 2 }}>
                {storeData.Points.avg}
              </Typography>
              <Rating
                defaultValue={storeData.Points.avg}
                precision={0.5}
                readOnly
              />
            </Box>
            <Grid container>
              <Grid item xs={6} p={3}>
                <Box
                  display="flex"
                  height="100%"
                  justifyContent="space-between"
                  alignItems="center"
                  sx={{
                    borderBottom: 1,
                    borderBottomStyle: "dashed",
                  }}
                >
                  <Typography>料理・味</Typography>
                  <Typography fontWeight="bold">
                    {storeData.Points.cooking}
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={6} p={3}>
                <Box
                  display="flex"
                  height="100%"
                  justifyContent="space-between"
                  alignItems="center"
                  sx={{
                    borderBottom: 1,
                    borderBottomStyle: "dashed",
                  }}
                >
                  <Typography>雰囲気</Typography>
                  <Typography fontWeight="bold">
                    {storeData.Points.atmosphere}
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={6} p={3}>
                <Box
                  display="flex"
                  height="100%"
                  justifyContent="space-between"
                  alignItems="center"
                  sx={{
                    borderBottom: 1,
                    borderBottomStyle: "dashed",
                  }}
                >
                  <Typography>接客・サービス</Typography>
                  <Typography fontWeight="bold">
                    {storeData.Points.service}
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={6} p={3}>
                <Box
                  display="flex"
                  height="100%"
                  justifyContent="space-between"
                  alignItems="center"
                  sx={{
                    borderBottom: 1,
                    borderBottomStyle: "dashed",
                  }}
                >
                  <Typography>コストパフォーマンス</Typography>
                  <Typography fontWeight="bold">
                    {storeData.Points.cost}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Box>

          <Divider />

          <Box>
            {filterChips.map((e) => (
              <SelectableChip
                value={e.label}
                label={
                  <Box display="flex">
                    <Typography marginRight={e.number ? 1 : 0}>
                      {e.label}
                    </Typography>
                    <Typography>{e.number}</Typography>
                  </Box>
                }
                onSelected={handleSeletedChip}
              />
            ))}
          </Box>

          {reviewList.map((e) => (
            <ReviewCard {...e} />
          ))}
        </Box>
      </Drawer>
    </>
  );
}
